import React from 'react';
import ActivityLoader from '../../components/Common/ActivityLoader';

const DailySalesTrendCard = ({
  dailyBreakdown,
  maxDaily,
  money,
  formatCount,
  loading,
  noData,
  styles,
}) => {
  return (
    <div className="card custom-card mb-4" style={styles.softCard}>
      <div className="card-body">
        <div className="d-flex align-items-center mb-3">
          <div>
            <h6 className="card-title mb-1">Daily Sales Trend</h6>
            <p className="text-muted tx-12 mb-0">
              Simple visual of revenue by day
            </p>
          </div>
          <div className="ml-auto text-right">
            <div className="text-muted small">Days</div>
            <div className="h6 mb-0">{dailyBreakdown.length}</div>
          </div>
        </div>

        {loading && <ActivityLoader />}
        {noData && <div className="text-muted">No daily sales available.</div>}

        {!loading && !noData && (
          <div className="d-flex flex-column gap-2 overflow-auto" style={{maxHeight: '135px'}}>
            {dailyBreakdown.map((r) => {
              const val = Number(r.amount_sold) || 0;
              const width = maxDaily > 0 ? (val / maxDaily) * 100 : 0;
              return (
                <div key={r.sale_date} className="d-flex align-items-center">
                  <div style={{ width: 110 }} className="text-muted small">
                    {r.sale_date}
                  </div>
                  <div className="flex-grow-1 mx-2">
                    <div
                      style={{
                        height: 8,
                        borderRadius: 999,
                        background: 'rgba(255,255,255,0.06)',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: `${width}%`,
                          height: '100%',
                          background:
                            'linear-gradient(90deg, rgba(59,130,246,0.9), rgba(16,185,129,0.9))',
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ width: 140 }} className="text-right small">
                    {money(r.amount_sold)}
                  </div>
                  <div style={{ width: 70 }} className="text-right text-muted small">
                    {formatCount(r.vouchers_sold)}
                  </div>
                </div>
              );
            })}

            {!dailyBreakdown.length && (
              <div className="text-muted text-center py-4">
                No daily sales for selected filters.
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DailySalesTrendCard;
